import { fetchLogAction } from './actions';

const getLogs = (dispatch) => (payload) => dispatch(fetchLogAction(payload));

const operations = {
  getLogs,
};

export default operations;
